import * as React from "react";
const SvgArrowLeftSmall24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 12,
        fill: "black",
        viewBox: "0 0 8 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m5.793.293 1.414 1.414L2.914 6l4.293 4.293-1.414 1.414L.086 6 5.793.293Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowLeftSmall24Px;
